<div class="text-center">
  <button routerLink="/seller/promo-code/create" class="btn btn-primary mb-4">
    {{ 'Sellers.Products.AddNewPromocode' | translate }}
  </button>
</div>

<div>
  <app-base-report [filterFields]="filterField"
                   [hasCheckboxes]="false"
                   [reportName]="reportName"
                   [defaultColumns]="Columns"
                   [columnsDisplayNames]="displayTableColumns"
                   [data]="promocodeReportData"
                   [rowsLength]="totalNumberOfRecords"
                   (filterTrigger)="filter($event)"
                   (paginationChange)="paginate($event)"
                   (searchChange)="searchChance($event)"
                   [tableLoading]="loading"
                   [hasSort]="true"
                   (sortTrigger)="sortChange($event)"
                   [serviceInstance]="fetchpromocodeService"
                   [rowActions]="rowActions"
                   (rowActionClicked)="onRowAction($event)"></app-base-report>
</div>

<div class="popup" *ngIf="promocodeProducts.length">
  <div class="d-flex justify-content-center align-items-center w-100 h-100">
    <div class="table-container text-center p-4 bg-white">
      <label class="all-products" *ngIf="!promocodeProducts[0]">
        {{ 'Sellers.Products.ProductsAssigned' | translate }}
      </label>
      <table *ngIf="promocodeProducts[0]" class="table">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">{{ 'Sellers.Products.ProductName' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let product of promocodeProducts; let i = index">
            <th>{{ i + 1 }}</th>
            <td>{{ product['productName'] }}</td>
          </tr>
        </tbody>
      </table>
      <div class="mt-3">
        <button class="btn btn-success" (click)="closePopup()">{{ 'Sellers.Products.Close' | translate }}</button>
      </div>
    </div>
  </div>
</div>
